import ContenidoTipoHistoriaAuto from './contenido-tipo-historia-auto';
import ContenidoTipoHistoriaAutoSegundaVentana from './contenido-tipo-historia-auto-segunda-ventana';
import ContenidoTipoHistoriaManual from './contenido-tipo-historia-manual';
import ContenidoTipoHistoriaManualSegundaVentana from './contenido-tipo-historia-manual-segunda-ventana';
import ContenidoTipoIframe from './contenido-tipo-iframe';
import ContenidoTipoVideo from './contenido-tipo-video'; // import ContenidoTipoZoom from './contenido-tipo-zoom/contenido-tipo-zoom-hooks'

import ContenidoTipoZoom from './contenido-tipo-zoom/contenido-tipo-zoom';
import ContenidoTipoFlashcards from './contenido-tipo-flashcards';
import ContenidoTipoPng from './contenido-tipo-png';
var ContenidoVentana = {
  ContenidoTipoHistoriaAuto: ContenidoTipoHistoriaAuto,
  ContenidoTipoHistoriaAutoSegundaVentana: ContenidoTipoHistoriaAutoSegundaVentana,
  ContenidoTipoHistoriaManual: ContenidoTipoHistoriaManual,
  ContenidoTipoHistoriaManualSegundaVentana: ContenidoTipoHistoriaManualSegundaVentana,
  ContenidoTipoIframe: ContenidoTipoIframe,
  ContenidoTipoVideo: ContenidoTipoVideo,
  ContenidoTipoZoom: ContenidoTipoZoom,
  ContenidoTipoFlashcards: ContenidoTipoFlashcards,
  ContenidoTipoPng: ContenidoTipoPng
};
export default ContenidoVentana;